import React, {Fragment} from 'react'
import {Table, TableBody, TableHead, TableRow, withStyles} from '@material-ui/core';
import styles from './styles'
import {withTranslation} from 'react-i18next';
import {compose} from 'recompose';
import PropTypes from 'prop-types';
import classNames from 'classnames'
import {Portlet, PortletContent, PortletHeader, TableCellWithConfig, TableSettings} from '../../index'
import Columns from './columns';
import useTableConfig from '../../../hooks/useTableConfig';
import DefaultConfig from './config';
import {getTableKey} from '../../../services/util/tableConfigHelper';
import {TableKind} from '../../../services/enums/TableKind';
import {displayModes} from '../../../services/enums/displayModes';

function TourStopTable(props) {

  const {
    classes,
    className,
    tour,
    showStopDetails,
    selectedStop,
    t,
    trackingStops,
    trackingStopsLoading,
    displayMode
  } = props;

  const rootClassName = classNames(classes.root, className);

  const {
    config,
    columnConfigs,
    updateConfig
  } = useTableConfig(DefaultConfig, displayMode, getTableKey(TableKind.TourStopTable, displayMode))

  return (
    <Fragment>
      <Portlet className={classNames(classes.tourStopTable, rootClassName)}>
        <PortletHeader>
          <Fragment>
            <div><strong>{t('stops')}</strong></div>
            <div><strong>{t('stopAmount')}</strong>: {tour.stops.length}</div>
          </Fragment>
        </PortletHeader>
        <PortletContent noPadding>
          <TableSettings
            updateConfig={updateConfig}
            tableConfig={config}
            columns={Columns}
          />
          <Table size="medium">
            <TableHead>
              <TableRow>
                {columnConfigs.map(columnConfig => (
                  <TableCellWithConfig
                    key={columnConfig.order}
                    config={columnConfig}
                  >
                    {Columns[columnConfig.columnName].header({t})}
                  </TableCellWithConfig>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {tour.stops.map((stop, index) => {
                const trackingStop = !trackingStopsLoading && trackingStops.length > 0 ? trackingStops.filter(ts => ts.finalStopId === stop.tourStopId)[0] : null;
                const lastTrackingStep = !trackingStopsLoading && trackingStop ? trackingStop.trackingSteps.sort((a, b) => new Date(b.eventTimeStamp) - new Date(a.eventTimeStamp))[0] : null;
                return (
                  <TableRow
                    className={classes.tableRow}
                    hover
                    key={index}
                    onClick={() => showStopDetails(stop)}
                    selected={selectedStop && stop.tourStopId === selectedStop.tourStopId}
                  >
                    {columnConfigs.map(columnConfig => (
                      <TableCellWithConfig
                        key={columnConfig.order}
                        config={columnConfig}
                        className={classes.tableCell}
                      >
                        {Columns[columnConfig.columnName].body({
                          stop,
                          classes,
                          t,
                          lastTrackingStep,
                          trackingStopsLoading
                        })}
                      </TableCellWithConfig>
                    ))}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </PortletContent>
      </Portlet>
    </Fragment>
  );
}


TourStopTable.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  displayMode: PropTypes.oneOf(Object.values(displayModes)).isRequired,
  selectedStop: PropTypes.object,
  showStopDetails: PropTypes.func,
  t: PropTypes.func.isRequired,
  tour: PropTypes.object.isRequired,
  trackingStops: PropTypes.array.isRequired,
  trackingStopsLoading: PropTypes.bool.isRequired,
};

export default compose(withStyles(styles), withTranslation())(TourStopTable);
